{
  "app": {
    "logoTitle": "Training Grant Data System",
    "logoSubtitle": "",
    "description": "Application for tracking and managing T32 and other grant submissions",
    "copyrightYear": "2026",
    "supportEmail": "NIH_Training_Grant_Data_System@stanford.edu"
  },
  "globals": {
    "notAvailable": "N/A",
    "form": {
      "actionButtons": {
        "yes": "YES",
        "no": "NO",
        "save": "SAVE",
        "cancel": "CANCEL",
        "back": "BACK",
        "send": "SEND",
        "next": "NEXT",
        "remove": "REMOVE",
        "copy": "COPY",
        "proceed": "PROCEED"
      }
    },
    "list": {
      "actionIcons": {
        "edit": {
          "label": "Edit",
          "tooltip": "Edit"
        },
        "delete": {
          "label": "Delete",
          "tooltip": "Delete",
          "dialog": {
            "dialogTitle": "Delete Submission",
            "dialogMessage": "Are you sure you want to delete the submission",
            "dialogCancel": "CANCEL",
            "dialogDelete": "DELETE"
          },
          "successMessage": "Submission deleted."
        },
        "remove": {
          "tooltip": "Remove"
        },
        "add": {
          "tooltip": "Add"
        },
        "done": {
          "tooltip": "Done"
        },
        "cancel": {
          "tooltip": "Cancel"
        },
        "auditIcon": {
          "tooltip": "Data is edited"
        }
      },
      "messages": {
        "noData": "No records to display",
        "fetchingInfo": "Loading ...",
        "wantToContinue": "Do you want to continue?",
        "noOptions": "No options"
      }
    },
    "title": {
      "submissions": "Manage Submissions",
      "faculty": "Participating Faculty and Their Research",
      "editFaculty": "Edit Faculty",
      "grants": "Training Grants",
      "editGrant": "Edit Training Grant",
      "trainees": "Trainee Demographics",
      "editTrainee": "Edit Trainee",
      "applicants": "Applicants",
      "outcomes": "Outcomes",
      "outputTable1": "Table 1. Census of Participating Departments and Interdepartmental Programs",
      "outputTable2": "Table 2. Participating Faculty Members",
      "outputTable3": "Table 3. Federal Institutional Research Training Grants and Related Support Available to Participating Faculty Members",
      "outputTable4": "Table 4. Research Support of Participating Faculty Members",
      "outputTable6A": "Table 6A. Applicants, Entrants, and their Characteristics for the Past Five Years: Predoctoral",
      "outputTable6B": "Table 6B. Applicants, Entrants, and their Characteristics for the Past Five Years: Postdoctoral",
      "outputTable8A": "Table 8A. Program Outcomes: Predoctoral",
      "outputTable8B": "Table 8B. Program Outcomes: Postdoctoral"
    },
    "metaDataInfo": {
      "generalHelpTitle": "General Help",
      "generalHelpDescription": "All listed names are Legal names. The name can be changed when you export the data on the Output Tables.",
      "exportTitleNormal": "Download as a spreadsheet.",
      "exportTitleTooMany": "Download as a spreadsheet. Due to the large number of records, this may take longer.",
      "noData": "No Data available.",
      "faculty": {
        "modalDescription": "Faculty are available if they are in PeopleSoft, or GST or in the NIH3 or NIH4 Faculty with Grants report that is imported monthly. "
      },
      "grants": {
        "modalDescription": "Grants are loaded from the NIH3 or NIH4 Faculty with Grants report for each faculty entered the Participating Faculty tab.  This report lists all faculty that are associated with any NIH Grant."
      },
      "trainees": {
        "modalDescription": "Trainees are searched for across PeopleSoft and a feed from the Office of Postdoctoral Affairs Office. Only trainees appointed or admitted in the past 15 years are included. Predoctoral trainees have degree types of MD or PhD. Postdoctoral trainees are classified as Medical Fellow or Postdoc."
      },
      "applicants": {
        "modalDescription": "Predoctoral Applicants: The source data comes from PeopleSoft for Department/IDPs, which reflects five completed academic years. The grant submission date determines the five-year period which includes the current academic year applicant data plus the prior four academic years. For example, a submission created with May 2024 date will include applicant records from academic years 2019-2024. Submission created with September 2024 date will include applicant records from academic years 2020-2025.<br />Postdoctoral Applicants: The data for these applications comes from OPA and PeopleSoft via the Trainee tab. For each postdoc trainee record within the determined five-year applicant period, an applicant record is automatically created."
      },
      "outcomes": {
        "modalDescription": "Prior Trainees are searched for across PeopleSoft and a feed from the Office of Postdoctoral Affairs Office. Only prior trainees appointed or admitted in the past 15 years are included. Predoctoral trainees have degree types of MD or PhD. Postdoctoral trainees are classified as Medical Fellow or Postdoc."
      }
    },
    "autocomplete": {
      "helperText": "Please type a name to search",
      "noResultsText": "No results found",
      "moreItemsText": "Top {{nResults}} results, enter more characters to refine.",
      "searchTooShortText": "Please enter {{nMinChars}} or more characters",
      "options": {
        "yes": "Yes",
        "no": "No"
      }
    }
  },
  "submission": {
    "create": {
      "title": "Create Submission",
      "form": {
        "fields": {
          "submissionName": {
            "label": "Submission Name",
            "placeHolder": "",
            "validation": {
              "isEmpty": "Submission Name is required.",
              "isDuplicate": "Submission Name already exists for the selected Submission Year."
            }
          },
          "submissionYear": {
            "label": "Submission Year",
            "placeHolder": "",
            "validation": {
              "isEmpty": "Submission Year is required."
            }
          },
          "submissionMonth": {
            "label": "Submission Month",
            "validation": {
              "isEmpty": "Submission month is required."
            }
          },
          "operationStatus": {
            "label": "Operation Status"
          },
          "grant": {
            "label": "Grant",
            "noOptionText": "Please type an Award number, SPO number or title to search"
          },
          "admins": {
            "label": "Submission Admins"
          },
          "observers": {
            "label": "Observers"
          },
          "spoNumber": {
            "label": "SPO Number"
          },
          "awardNumber": {
            "label": "Award Number"
          },
          "grantTitle": {
            "label": "Grant Title"
          },
          "autoLoad": {
            "label": "Auto Load",
            "tooltip": "Automatically load and remove Trainees, Applicants and Outcomes when a Faculty is added or removed using the Faculty Tab"
          },
          "autoLoadEnabled": "Auto Load Enabled"
        }
      },
      "notification": {
        "success": "Submission {{submissionName}} created.",
        "update": "Submission {{submissionName}} updated.",
        "submissionNotFoundError": "Submission {{submissionName}} is no longer accessible.",
        "submissionOptStatusTimeoutError": "TGDS encountered a timeout while checking on the submissions. Feel free to browse other parts of the web application while the loading/copying process continues in the background. You can also reload the page to refresh the data manually."
      }
    },
    "edit": {
      "title": "Edit Submission"
    },
    "manage": {
      "title": "Manage Submissions",
      "ctaTextForCreateSubmission": "Create Submission",
      "submissionList": {
        "tableColumns": {
          "submissionName": "Submission Name",
          "submissionYearMonth": "Submission Month/Year",
          "operationStatus": "Operation Status",
          "spoNumber": "SPO #",
          "submissionAdmin": "Submission Admin(s)",
          "observer": "Observer(s)",
          "actions": "Actions"
        },
        "dataLoadingText": "Loading ..."
      }
    },
    "copy": {
      "copyButtonText": "Copy Admin Changes",
      "title": "Copy Administrative Changes",
      "helpText": "System Administrators can copy administrative changes from a previous submission to another. This includes modifications to add, update, or remove faculties, grants, trainees, applicants, and outcomes. New records not present in the destination will be copied. Existing records in the destination submission will be updated to reflect changes from the source, including any removals. Please note that time limits apply: Trainees and Outcomes records from the past 15 years will be considered during copy, while Applicants are limited to the past 5 years.",
      "confirmationMessage": "You are about to copy admin changes. This operation cannot be undone. When the copy operation completes, the operation status on the destination will change to Ready.",
      "labels": {
        "sourceSubmission": "Source Submission",
        "destinationSubmission": "Destination Submission"
      },
      "notification": {
        "success": "Copying of Submission {{sourceSubName}} to {{destinationSubName}} started. Please check Submission operation status for details",
        "error": "Copying of Submission {{sourceSubName}} to {{destinationSubName}} failed. Please check Submission operation status for details."
      },
      "tableColumns": {
        "monthYear": "Month/Year",
        "spo": "SPO",
        "award": "Award",
        "title": "Title"
      }
    },
    "operationStatus": {
      "ready": "Ready",
      "copyInProgress": "Copying In-Progress",
      "loadInProgress": "Loading In-Progress",
      "failed": "Failed"
    },
    "filterPanelItems": {
      "title": "Filters",
      "reset": "Reset All Filters",
      "options": {
        "submissionName": {
          "label": "Submission Name"
        },
        "submissionYear": {
          "label": "Submission Year"
        },
        "submissionAdmin": {
          "label": "Submission Admin"
        },
        "observer": {
          "label": "Observer"
        }
      }
    }
  },
  "faculty": {
    "title": "Participating Faculty",
    "mainView": {
      "submission": "Submission",
      "participatingFaculty": "Add Participating Faculty",
      "list": {
        "tableColumns": {
          "name": "Name",
          "orcidID": "ORCID iD",
          "email": "Email",
          "degree": "Degree(s)",
          "rank": "Rank",
          "primaryDepartment": "Primary Department or Program",
          "researchInterest": "Research Interest",
          "trainingRole": "Training Role(s)",
          "commonsID": "Commons ID",
          "actions": "Actions"
        },
        "dataLoadingText": "Loading ...",
        "noData": "Please add Participating Faculty to see demographic details."
      },
      "filters": {
        "primaryName": "Primary Name",
        "rank": "Rank",
        "degree": "Degree",
        "trainingRole": "Training Role",
        "program": "Program"
      }
    },
    "edit": {
      "title": "Edit Faculty",
      "facultyList": {
        "orcidId": "ORCID iD",
        "email": "Email",
        "degrees": "Degrees",
        "rank": "Rank",
        "primaryDepProg": "Primary Department or Program",
        "researchInterest": "Research Interest",
        "trainingRole": "Training Role",
        "commonsID": "Commons ID"
      },
      "trainingRole": {
        "executiveCommitteeMember": "Executive Committee member",
        "other": "Other",
        "otherCommitteeMember": "Other Committee member",
        "pdPI": "PD/PI",
        "preceptor": "Preceptor"
      },
      "commonsIdError": "Commons ID already exists in the system."
    },
    "notification": {
      "addFaculty": "Faculty {{facultyName}} and their Grants have been added",
      "addFacultyWithAutoLoad": "Faculty {{facultyName}} and their Grants have been added. The Trainee, Applicants, and Outcomes screens will take a few minutes to update. After a few minutes you will see the updates when you visit or refresh those screens.",
      "errorAddFaculty": "There has been an error updating trainees or applicants for {{facultyName}}. Please, contact {{support}}.",
      "facultyNotFound": "Faculty with id \"{{facultyName}}\" not found.",
      "duplicateFaculty": "Faculty already assigned to the given submission.",
      "updateFaculty": "Faculty {{facultyName}} updated.",
      "addTimeout": "TGDS encountered a timeout while checking on the faculty loading process. Feel free to browse other parts of the web application while the loading process continues in the background. You can also reload the page to refresh the data manually.",
      "deleteTimeout": "TGDS encountered a timeout while checking on the faculty deletion process. Feel free to browse other parts of the web application while the deletion process continues in the background. You can also reload the page to refresh the data manually.",
      "email": "Invalid email address"
    },
    "delete": {
      "confirmationBox": {
        "deleteRecord": {
          "title": "Remove Participating Faculty",
          "body": "Are you sure you want to remove \"{{name}}\"?",
          "cancelLabel": "CANCEL",
          "okLabel": "REMOVE"
        },
        "deleteAllRecord": {
          "title": "Remove All Participating Faculty",
          "body": "Are you sure you want to remove all participating faculty members from Submission \"{{name}}\"?",
          "cancelLabel": "CANCEL",
          "okLabel": "REMOVE ALL"
        }
      },
      "deleteAllButtonText": "REMOVE ALL",
      "deleteSuccessMessage": "Participating Faculty removed",
      "deleteAllSuccessMessage": "All Faculty members removed"
    },
    "export": {
      "exportButtonText": "EXPORT"
    },
    "autocomplete": {
      "noResultsText": "No faculty with that name found"
    }
  },
  "grant": {
    "title": "Training Grants",
    "mainView": {
      "submission": "Submission",
      "noData": "No Training Grants Available",
      "list": {
        "tableColumns": {
          "spoNumber": "SPO #",
          "title": "Title",
          "awardNumber": "Award Number",
          "projectPeriod": "Project Period",
          "pd": "PD/PI",
          "grantRole": "Grant Role",
          "fundingSource": "Funding Source",
          "budgetPeriodDirectCost": "Budget Period Direct Cost",
          "budgetPeriodTotalCost": "Budget Period Total Cost",
          "currentBudgetPeriod": "Current Budget Period",
          "department": "Department",
          "grantYear": "Grant Year",
          "preDocsPositions": "Pre-doc Positions",
          "postDocsPositions": "Post-doc Positions",
          "shortTermPositions": "Short-term Positions",
          "participatingFaculty": "Participating Faculty / (Overlapping)",
          "overLappingFaculty": "Overlapping Faculty",
          "isInstituional": "Institutional",
          "actions": "Actions"
        },
        "dataLoadingText": "Loading ...",
        "noData": "No Data available."
      },
      "delete": {
        "confirmationBox": {
          "title": "Remove Grant",
          "body": "Are you sure you want to remove \"{{name}}\"?",
          "cancelLabel": "CANCEL",
          "okLabel": "REMOVE"
        }
      },
      "addGrantMessage": "Grant {{grantName}} added",
      "removeGrantMessage": "Grant {{grantName}} removed",
      "filters": {
        "title": "Title",
        "awardNumber": "Award Number",
        "projectStartDate": "Project Start Date",
        "projectEndDate": "Project End Date",
        "pdPi": "PD/PI",
        "grantRole": "Grant Role",
        "dateSeparator": "to",
        "invalidDateFormat": "Invalid Date"
      }
    },
    "edit": {
      "title": "Edit Training Grant",
      "grantList": {
        "pd": "PD/PI",
        "role": "Select Grant Role",
        "fundingSource": "Funding Source",
        "overlappingFaculty": "Overlapping Faculty",
        "currentYearCost": "Current Year Cost",
        "preDocsPositions": "Pre-doc Positions",
        "postDocsPositions": "Post-doc Positions",
        "shortTermPositions": "Short-term Positions",
        "participatingFaculty": "Participating Faculty",
        "institutional": "This is an Institutional Grant",
        "startDate": "Project Start Date",
        "endDate": "Project End Date",
        "roles": "Grant Roles"
      },
      "maxDateMessage": "Start Date should be equal to or less than End Date",
      "minDateMessage": "End Date should be equal to or greater than Start Date."
    },
    "notification": {
      "updateGrants": "Training Grant {{title}} updated."
    }
  },
  "trainee": {
    "title": "Trainee Demographics",
    "mainView": {
      "addTrainee": "Add Trainee",
      "duplicateTrainee": "Trainee already assigned to the given submission",
      "ineligibleTrainee": "Trainee is not eligible for the Submission",
      "notFound": "Trainee not found",
      "removeAll": {
        "label": "REMOVE TRAINEE(S)",
        "tooltip": "REMOVE TRAINEE(S)"
      },
      "list": {
        "tableColumns": {
          "trainee": "Trainee",
          "orcidId": "ORCID iD",
          "commonsId": "Commons ID",
          "faculty": "Participating Faculty",
          "departments": "Participating Department / Interdepartmental Program",
          "stanfordEmail": "Stanford Email",
          "trainingDate": "Training Period",
          "citizenship": "Citizenship",
          "ethnicity": "Ethnicity",
          "type": "Type",
          "currentTrainee": "Current Trainee",
          "grantEligible": "Eligible Trainee with Participating Faculty",
          "hhsSupport": "HHS Support",
          "tgeSupport": "TGE Support",
          "r90Support": "R90 Support",
          "actions": "Actions",
          "notAvailable": "N/A",
          "yes": "Yes",
          "no": "No"
        },
        "noData": "No data available"
      },
      "filters": {
        "traineeName": "Trainee",
        "participatingDepartment": "Department / Program",
        "faculty": "Faculty",
        "trainingStartDate": "Training Start Date",
        "trainingEndDate": "Training End Date",
        "traineeType": "Type",
        "dateSeparator": "to",
        "invalidDateFormat": "Invalid Date",
        "currentTrainee": "Current Trainee",
        "traineeTypeOptions": {
          "preDoc": "Pre-doc",
          "postDoc": "Post-doc",
          "shortTerm": "Short-term"
        },
        "isActive": "Is Active"
      },
      "removeTraineeMessage": "Trainee removed",
      "addTraineeMessage": "Trainee added.  The Applicants screens will take a few minutes to update. After a few minutes you will see the updates when you visit or refresh those screens.",
      "delete": {
        "confirmationBox": {
          "title": "Remove Trainees",
          "body": "You are about to remove {{count}} trainee{{plural}}.",
          "cancelLabel": "Cancel",
          "okLabel": "Remove"
        }
      }
    },
    "edit": {
      "title": "Edit Trainee",
      "traineeForm": {
        "orcidId": "ORCID iD",
        "commonsID": "Commons ID",
        "faculty": "Participating Faculty",
        "mentor": "Faculty/Mentor",
        "departments": "Participating Department / Interdepartmental Program",
        "stanfordEmail": "Stanford Email",
        "trainingStartDate": "Training Start Date",
        "trainingEndDate": "Training End Date",
        "citizenship": "Citizenship",
        "ethnicity": "Ethnicity",
        "type": "Type",
        "currentTrainee": "Current Trainee",
        "grantEligible": "Eligible Trainee with Participating Faculty",
        "hhsSupport": "HHS Support",
        "tgeSupport": "TGE Support",
        "r90Support": "R90 Support",
        "ethnicityValues": {
          "americanIndianOrAlaskaNative": "American Indian or Alaska Native",
          "asian": "Asian",
          "blackOrAfricanAmerican": "Black or African American",
          "hispanicOrLatino": "Hispanic or Latino",
          "nativeHawaiianOrOtherPacificIslander": "Native Hawaiian or Other Pacific Islander",
          "white": "White",
          "other": "Other/Unknown",
          "moreThanOneRace": "More than One Race",
          "internationalOrNonResident": "International/Nonresident"
        },
        "invalidDateFormat": "Invalid Date",
        "commonsIdError": "Commons ID already exists in the system.",
        "emailIdError": "Invalid email address.",
        "facultyNotFoundError": "Faculty not found",
        "maxDateMessage": "Start Date should be equal to or less than End Date",
        "minDateMessage": "End Date should be equal to or greater than Start Date.",
        "citizenshipHelperText": "Enter a country name"
      }
    },
    "notification": {
      "updateTrainee": "Trainee Demographics for {{traineeFullName}} updated.  The Applicants screens will take a few minutes to update. After a few minutes you will see the updates when you visit or refresh those screens.",
      "email": "Invalid email address"
    }
  },
  "output": {
    "mainView": {
      "list": {
        "tableColumns": {
          "name": "Name",
          "grantTitle": "Grant Title",
          "awardNumber": "Award Number",
          "projectPeriod": "Project Period",
          "pd/pi": "PD/PI",
          "preDoctoral": "Number of Predoctoral Positions",
          "postDoctoral": "Number of Postdoctoral Positions",
          "shortTerm": "Number of Short-Term Positions",
          "participatingFaculty": "Number of Participating Faculty (Number Overlapping)",
          "overLappingFaculty": "Names of Overlapping Faculty",
          "degrees": "Degree(s)",
          "rank": "Rank",
          "department": "Primary Department or Program",
          "intrest": "Research Interest",
          "training": "Training Role",
          "predocs": "Pre-doctorates in Training",
          "predocsGraduated": "Pre-doctorates Graduated",
          "predocsContinued": "Pre-doctorates Continued in Research or Related Careers ",
          "postdocs": "Post-doctorates in Training",
          "postdocsGraduated": "Post-doctorates Completed Training",
          "postdocsContinued": "Post-doctorates Continued in Research or Related Careers ",
          "roleOnProject": "Role on Project",
          "grantNumber": "Grant Number",
          "fundingSource": "Funding Source",
          "currentYearDirectCost": "Current Year Direct Cost",
          "facultyMembers": "Faculty Member",
          "avgGrantSupport": "Average Grant Support per Participating Faculty Member",
          "table1": {
            "predoctorates": {
              "participatingDeptOrProgram": "Participating Department or Program",
              "totalFaculty": "Total Faculty",
              "participatingFaculty": "Participating Faculty based on Submission Trainees",
              "totalParticipatingFaculty": "Participating Faculty based on Submission Faculty",
              "totalDoctorates": "Total Predoctorates",
              "totalDoctoratesSupportByHhsAward": "Total Predoctorates Supported by any HHS Training Award",
              "totalDoctoratesWithParticipatingFaculty": "Total Predoctorates with Participating Faculty",
              "eligibleWithParticipatingFaculty": "Eligible Predoctorates with Participating Faculty",
              "supportByTrainingGrantTge": "Training Grant Eligible (TGE) Predoctorates Supported by this Training Grant (Renewals/ Revisions)",
              "supportByTrainingGrantRninezero": "Predoctorates Supported by this Training Grant(R90 Only Renewals/ Revisions)"
            },
            "postdoctorates": {
              "participatingDeptOrProgram": "Participating Department or Program",
              "totalFaculty": "Total Faculty",
              "participatingFaculty": "Participating Faculty based on Submission Trainees",
              "totalParticipatingFaculty": "Participating Faculty based on Submission Faculty",
              "totalDoctorates": "Total Postdoctorates",
              "totalDoctoratesSupportByHhsAward": "Total Postdoctorates Supported by any HHS Training Award",
              "totalDoctoratesWithParticipatingFaculty": "Total Postdoctorates with Participating Faculty",
              "eligibleWithParticipatingFaculty": "Eligible Postdoctorates with Participating Faculty",
              "supportByTrainingGrantTge": "Training Grant Eligible (TGE) Postdoctorates Supported by this Training Grant (Renewals/ Revisions)",
              "supportByTrainingGrantRninezero": "Postdoctorates Supported by this Training Grant(R90 Only Renewals/ Revisions)"
            }
          },
          "table6A": {
            "counts": {
              "mostRecentlyCompletedYear": "Most Recently Completed Year: {{recentCompletionYear}}",
              "totalApplicantPool": "Total Training Program Candidates - Applied",
              "applicantsEligibleForSupport": "Total Training Program Candidates - Eligible for Support",
              "totalCandidatesApplied": "Total Training Program Candidates - Applied",
              "totalCandidatesEligible": "Total Training Program Candidates - Eligible for Support",
              "newEntrantsToProgram": "New Entrants to the Program",
              "newEntrantsEligibleForSupport": "New Entrants Eligible for Support",
              "newEntrantsAppointed": "New Appointees to this Grant (Renewal/Revision Applicants Only)",
              "previousYear": "Previous Year: {{previousCompletionYear}}",
              "summaryTable": "Total All Years"
            },
            "characteristics": {
              "tabLabel": "PART II. CHARACTERISTICS",
              "MEAN_MONTH_OF_PRIOR_AND_FULLTIME_RESEARCH_EXPERIENCE": "Mean Months of Prior, Full-Time Research Experience (range)",
              "PRIOR_INSTITUTIONS": "Prior Institutions",
              "PERCENT_FROM_UNDERREPRESENTED_RACIAL_AND_ETHNIC_GROUPS": "Percent from Underrepresented Groups",
              "MEAN_GPA_RANGE": "Mean GPA (range)",
              "summaryTable": "Means Across All Years",
              "summary": {
                "MEAN_MONTH_OF_PRIOR_AND_FULLTIME_RESEARCH_EXPERIENCE": "Mean Months of Prior, Full-Time Research Experience",
                "PERCENT_FROM_UNDERREPRESENTED_RACIAL_AND_ETHNIC_GROUPS": "Percent from Underrepresented Groups",
                "MEAN_GPA_RANGE": "Mean GPA"
              }
            },
            "modalBox": {
              "name": "Name",
              "sunetId": "SUNet ID"
            }
          },
          "table6B": {
            "counts": {
              "mostRecentlyCompletedYear": "Most Recently Completed Year: {{recentCompletionYear}}",
              "totalApplicantPool": "Total Training Program Candidates - Applied",
              "applicantsEligibleForSupport": "Total Training Program Candidates - Eligible for Support",
              "totalCandidatesApplied": "Total Training Program Candidates - Applied",
              "totalCandidatesEligible": "Total Training Program Candidates - Eligible for Support",
              "newEntrantsToProgram": "New Entrants to the Program",
              "newEntrantsEligibleForSupport": "New Entrants Eligible for Support",
              "newEntrantsAppointed": "New Appointees to this Grant (Renewal/Revision Applicants Only)",
              "previousYear": "Previous Year: {{previousCompletionYear}}",
              "summaryTable": "Means Across All Years"
            },
            "characteristics": {
              "tabLabel": "PART II. CHARACTERISTICS",
              "MEAN_NUMBER_OF_PUBLICATIONS": "Mean Number of Publications (range)",
              "MEAN_NUMBER_OF_FIRST_AUTHOR_PUBLICATIONS": "Mean Number of First-Author Publications (range)",
              "PRIOR_INSTITUTIONS": "Prior Institutions",
              "PERCENT_FROM_UNDERREPRESENTED_RACIAL_AND_ETHNIC_GROUPS": "Percent from Underrepresented Groups",
              "summaryTable": "Means Across All Years",
              "summary": {
                "MEAN_NUMBER_OF_PUBLICATIONS": "Mean Number of Publications",
                "MEAN_NUMBER_OF_FIRST_AUTHOR_PUBLICATIONS": "Mean Number of First-Author Publications",
                "PERCENT_FROM_UNDERREPRESENTED_RACIAL_AND_ETHNIC_GROUPS": "Percent from Underrepresented Groups"
              }
            },
            "modalBox": {
              "name": "Name",
              "sunetId": "SUNet ID"
            }
          },
          "table8": {
            "predoctoral": {
              "trainee": "Trainee",
              "facultyMember": "Faculty Member",
              "startDate": "Start Date",
              "summaryOfSupport": "Summary of Support During Training",
              "terminalDegreeReceivedYear": "Terminal Degree(s) Received and Year(s)",
              "topicOfResearchProject": "Topic of Research Project",
              "initialPosition": "Initial Position",
              "currentPosition": "Current Position",
              "subsequentGrant": "Subsequent Grant(s)/Role/Year Awarded"
            },
            "postdoctoral": {
              "trainee": "Trainee",
              "doctoralDegreeAndYear": "Doctoral Degree(s) and Year(s)",
              "facultyMember": "Faculty Member",
              "startDate": "Start Date",
              "summaryOfSupport": "Summary of Support During Training",
              "resultingDegreeReceivedYear": "Degree(s) Resulting from Postdoctoral Training and Year(s)",
              "topicOfResearchProject": "Topic of Research Project",
              "initialPosition": "Initial Position",
              "currentPosition": "Current Position",
              "subsequentGrant": "Subsequent Grant(s)/Role/Year Awarded"
            },
            "tabLabels": {
              "predoctoral": "PREDOCTORAL",
              "postdoctoral": "POSTDOCTORAL"
            }
          }
        },
        "noData": "No Data available."
      }
    },
    "modalDialog": {
      "list": {
        "tableColumns": {
          "name": "Name",
          "sunetId": "SUNet ID"
        }
      }
    },
    "table1": {
      "tooltips": {
        "noFacultyRecords": "Unable to calculate total faculty count using available data",
        "noTraineeRecords": "No trainees are associated with this department. Typically a faculty's appointed administrative org differs from a trainees academic org",
        "dataComesFromAdmin": "This data comes from admin"
      },
      "modalDialog": {
        "totalFaculty": {
          "dataSourceDescPeopleSoft": "The source of this data is PeopleSoft and is limited to faculty assigned to this department/division as their primary appointment.  More details at ",
          "dataSourceDescGst": {
            "description0": "The Source of this data is the Graduate Student Tracking system (GST). More details at ",
            "description1": " This may differ from the department academic roster available in ",
            "href": "https://oge.stanford.edu/academics/graduate-student-tracking/",
            "hrefName": "GST"
          },
          "dataSourceDescDefault": "No faculty in the professoriate were found in PeopleSoft or the Graduate Student Tracking System (GST) for this participating department or program.",
          "dataSourceDescFarm": {
            "href": "https://med.stanford.edu/academicaffairs/tools/farm-info.html",
            "hrefName": "FARM"
          }
        },
        "totalPreDocs": {
          "dataSourceDescPeopleSoft": "This list of predocorates was generated from PeopleSoft",
          "dataSourceDescDefault": "No predoctorates were found in PeopleSoft for this participating department or program"
        },
        "totalPostDocs": {
          "dataSourceDescOpa": "This list of postdoctorates was generated from the Office of Postdoctoral Affairs",
          "dataSourceDescDefault": "No postdoctorates were found in feed from the Office of Postdoctoral Affairs for this participating department or program."
        }
      }
    }
  },
  "applicants": {
    "title": "Applicants",
    "mainView": {
      "addApplicant": "Add Applicant",
      "createApplicant": "Create Applicant",
      "duplicateApplicant": "Applicant already assigned to the given submission",
      "removeAll": {
        "label": "REMOVE APPLICANT(S)"
      },
      "list": {
        "tableColumns": {
          "applicantName": "Applicant",
          "participatingDepartment": "Participating Department(s) / Interdepartmental Program(s)",
          "applicantType": "Type",
          "applicationYear": "Application Year",
          "faculty": "Faculty",
          "acceptedYear": "Accepted Year",
          "newEntrant": "New Entrant",
          "grantEligible": "Eligible For Support",
          "actions": "Actions",
          "notAvailable": "N/A"
        },
        "noData": "No Applicants."
      },
      "filters": {
        "applicantName": "Applicant",
        "participatingDepartment": "Department(s) / Program(s)",
        "applicationYear": "Application Year",
        "acceptedYear": "Accepted Year",
        "applicantType": "Type",
        "newEntrant": "New Entrant",
        "grantEligible": "Eligible For Support",
        "applicantTypeOptions": {
          "preDoc": "Pre-doc",
          "postDoc": "Post-doc",
          "both": "Both"
        },
        "isActive": "Is Active"
      },
      "popup": {
        "applicantType": "Type",
        "applicationYear": "Application Year",
        "acceptedYear": "Accepted Year",
        "isNewEntrant": "New Entrant",
        "isGrantEligible": "Eligible For Support",
        "isUnderrepresented": "Underrepresented",
        "priorInstitution": "Prior Institution",
        "citizenship": "Citizenship",
        "ethnicity": "Ethnic Group",
        "degrees": "Degree(s)",
        "totalPublications": "Total Publications",
        "totalPublicationsFirstAuthor": "Total Publications (First Author)",
        "departments": "Participating Department(s) / Interdepartmental Program(s)",
        "ftResearchExperience": "FT Research Experience (in Months)",
        "gpa": "GPA",
        "isDisabled": "Disabled",
        "PRE_DOC": "Pre-doc",
        "POST_DOC": "Post-doc"
      },
      "removeApplicantMessage": "Applicant removed",
      "addApplicantMessage": "Applicant added",
      "delete": {
        "confirmationBox": {
          "title": "Remove Applicants",
          "body": "You are about to remove {{count}} applicant{{plural}}.",
          "cancelLabel": "CANCEL",
          "okLabel": "REMOVE"
        }
      }
    },
    "create": {
      "title": "Create Applicant",
      "new": "New Applicant",
      "edit": "Edit Applicant",
      "applicantForm": {
        "applicants": "Applicant",
        "applicantsLastName": "Applicant Last Name",
        "applicantsFirstName": "Applicant First Name",
        "applicantsMiddleName": "Applicant Middle Name",
        "applicantType": "Type",
        "appYr": "Application Year",
        "acceptYr": "Accepted Year"
      },
      "notification": {
        "success": "Applicant {{applicantName}} created.",
        "update": "Applicant {{applicantName}} updated."
      }
    },
    "edit": {
      "citizenship": "Citizenship",
      "ethnicGroup": "Ethnic Group",
      "degrees": "Degrees",
      "totalPublication": "Total Publication",
      "totalPublicationFirstAuthor": "Total Publication (First Author)",
      "acceptedYearMessage": "Accepted year should be greater than or equal to Application year",
      "participatingDepartment": "Participating Department(s) / Interdepartmental Program(s)",
      "researchExperience": "FT Research Experience (in Months)",
      "grantEligible": "Eligible For Support",
      "newEntrant": "New Entrant",
      "underRepresented": "Underrepresented",
      "disabled": "Disabled"
    }
  },
  "outcomes": {
    "title": "Outcomes",
    "mainView": {
      "addGraduatedTrainee": "Add Past Trainee",
      "ineligibleTrainee": "Trainee is not eligible for the Submission",
      "sendInformationRequest": {
        "label": "Send Request",
        "tooltip": "Send Information request to the individuals selected."
      },
      "removeOutcomes": {
        "label": "Remove Outcome(s)",
        "notification": {
          "outcomesRemoved": "Removed {{numberOfTrainees}} Trainees."
        }
      },
      "filters": {
        "traineeName": "Trainee",
        "traineeType": "Type",
        "faculty": "Faculty",
        "trainingStartDate": "Training Start Date",
        "trainingEndDate": "Training End Date",
        "dateSeparator": "to",
        "isActive": "Is Active"
      },
      "list": {
        "tableColumns": {
          "trainee": "Trainee",
          "invitationStatus": "Status",
          "lastInvitedDate": "Request Date",
          "traineeType": "Type",
          "degrees": "Degree(s)",
          "faculty": "Faculty",
          "trainingPeriod": "Training Period",
          "supportDuringTraining": "Support During Training",
          "resultingDegrees": "Resulting Degree(s)",
          "researchTopic": "Research Topic",
          "initialSummary": "Initial Summary",
          "currentSummary": "Current Summary",
          "subsequentGrant": "Subsequent Grant(s): Role and Year Awarded",
          "actions": "Actions",
          "notAvailable": "Not Available",
          "position": "Position",
          "department": "Department",
          "institution": "Institution",
          "workforceSector": "Workforce Sector",
          "activity": "Activity"
        },
        "trainingSupportYearNonNihHhsDisplay": "TY{{trainingYearNumber}}: {{trainingSource}} {{trainingType}}",
        "trainingSupportYearNihHhsDisplay": "TY{{trainingYearNumber}}: {{nihHhsComponentAndActivity}}",
        "noData": "No Past Trainees",
        "invitationStatusValues": {
          "initiated": "Email Queued",
          "submitted": "Information Submitted",
          "sent": "Email Sent",
          "failed": "Email Failed",
          "notSent": "Email Not Sent",
          "reSent": "Email Re-sent"
        }
      },
      "addPastTraineeToOutcomeMessage": "Past Trainee Added",
      "addOutcomeMessage": "Outcome added",
      "removeOutcomeMessage": "Outcome removed",
      "delete": {
        "confirmationBox": {
          "title": "Remove Outcome",
          "body": "You are about to remove {{count}} outcome{{plural}}.",
          "cancelLabel": "CANCEL",
          "okLabel": "REMOVE"
        }
      }
    },
    "create": {
      "title": "Create Outcome",
      "new": "New Outcome",
      "outcomeForm": {
        "traineeLastName": "Trainee Last Name",
        "traineeFirstName": "Trainee First Name",
        "traineeMiddleName": "Trainee Middle Name",
        "traineeEmail": "Trainee Email",
        "outcome": "Outcome",
        "traineeType": "Type",
        "degree": "Degree",
        "degrees": "Degree(s)",
        "year": "Year",
        "mentor": "Mentor",
        "acceptYr": "Outcome Year",
        "summarySupport": "Summary of Support during Training",
        "trainingYear": "Training Year",
        "grant": "Grant",
        "resultingDegree": "Resulting Degree(s)",
        "researchTopic": "Research Topic",
        "initialSummary": "Initial Summary",
        "position": "Position",
        "department": "Department",
        "institution": "Institution",
        "workforceSector": "Workforce Sector",
        "activity": "Activity",
        "currentSummary": "Current Summary",
        "role": "Role",
        "subsGrant": "Subsequent Grant(s) Awarded"
      },
      "notification": {
        "success": "Outcome {{applicantName}} created."
      }
    },
    "edit": {
      "title": "Edit Outcome",
      "outcomeForm": {
        "trainingStartDate": "Training Start Date",
        "trainingEndDate": "Training End Date",
        "invalidDateFormat": "Invalid Date",
        "maxDateMessage": "Start Date should be equal to or less than End Date",
        "minDateMessage": "End Date should be equal to or greater than Start Date.",
        "terminalDegreeValues": {
          "md": "M.D.",
          "phd": "Ph.D.",
          "inTraining": "In Training",
          "none": "None"
        },
        "resultingDegreeValues": {
          "md": "M.D.",
          "phd": "Ph.D.",
          "scd": "Sc.D.",
          "dds": "D.D.S.",
          "dmd": "D.M.D.",
          "dc": "D.C.",
          "do": "D.O.",
          "dvm": "D.V.M.",
          "od": "O.D.",
          "dpm": "D.P.M.",
          "engD": "Eng.D.",
          "drPh": "Dr. P.H.",
          "dnSc": "D.N.Sc.",
          "dpt": "D.P.T.",
          "pharmD": "Pharm.D.",
          "nd": "N.D.",
          "dsw": "D.S.W.",
          "psyD": "Psy.D.",
          "inTraining": "In Training",
          "none": "None",
          "other": "Other"
        },
        "positionActivityValues": {
          "primarilyResearch": "Primarily Research",
          "primarilyTeaching": "Primarily Teaching",
          "primarilyClinical": "Primarily Clinical",
          "researchRelated": "Research-Related",
          "furtherTraining": "Further Training",
          "unrelatedToResearch": "Unrelated to Research"
        },
        "positionWorkforceSectorValues": {
          "academia": "Academia",
          "goverment": "Goverment",
          "forProfit": "For-profit",
          "nonprofit": "Nonprofit",
          "other": "Other"
        },
        "subsequentGrantRoleValues": {
          "principalInvestigator": "Principal Investigator",
          "coInvestigator": "Co-investigator",
          "facultyCollaborator": "Faculty collaborator",
          "staffScientist": "Staff scientist",
          "other": "Other"
        },
        "trainingSupportTypeValues": {
          "nihHhs": {
            "longName": "NIH/HHS",
            "shortName": "NIH/HHS"
          },
          "ra": {
            "longName": "Research assistantship (RA)",
            "shortName": "RA"
          },
          "ta": {
            "longName": "Teaching assistantship (TA)",
            "shortName": "TA"
          },
          "f": {
            "longName": "Fellowship (F)",
            "shortName": "F"
          },
          "tg": {
            "longName": "Training Grant (TG)",
            "shortName": "TG"
          },
          "s": {
            "longName": "Scholarship (S)",
            "shortName": "S"
          },
          "other": {
            "longName": "Other",
            "shortName": "Other"
          },
          "rg": {
            "longName": "Research Grant (RG)",
            "shortName": "RG"
          }
        },
        "trainingSupportSourceValues": {
          "nsf": {
            "longName": "NSF",
            "shortName": "NSF"
          },
          "otherFed": {
            "longName": "Other Federal (Other Fed)",
            "shortName": "Other Fed"
          },
          "univ": {
            "longName": "University (Univ)",
            "shortName": "Univ"
          },
          "fdn": {
            "longName": "Foundation (Fdn)",
            "shortName": "Fdn"
          },
          "nonUs": {
            "longName": "Non-US",
            "shortName": "Non-US"
          },
          "other": {
            "longName": "Other",
            "shortName": "Other"
          },
          "none": {
            "longName": "None: Leave of Absence (LOA)",
            "shortName": "LOA"
          }
        },
        "trainingSupportSummary": "Summary of Support during Training",
        "trainingYear": "Training Year",
        "trainingYearNihHhsComponentAndActivity": "NIH/HHS Component & Activity",
        "trainingSource": "Training Source",
        "trainingType": "Training Type",
        "helperText": {
          "nihHhsComponentAndActivity": "Recommended format - 2 letters, space, 1 letter, 2 numbers. Example: HL T32"
        }
      }
    },
    "trainingYearDisplay": "TY{{trainingYearNumber}}",
    "notification": {
      "updateOutcome": "Outcome for {{traineeFullName}} updated.",
      "email": "Invalid email address"
    }
  },
  "sendInvitation": {
    "title": "Send Information Request to {{numberOfTrainees}} Individuals",
    "fromEmailAddress": "From Email Address",
    "fromName": "From Name",
    "replyToEmailAddress": "Reply To Email Address",
    "subject": "Subject",
    "message": "Message",
    "notification": {
      "emailInvitationSent": "Information request sent to {{numberOfTrainees}} individuals.",
      "email": "Invalid email address"
    },
    "stepLabels": {
      "verifyTraineeList": "Verify Trainee List",
      "provideEmailDetails": "Provide Email Details",
      "previewAndSend": "Preview & Send"
    }
  },
  "removedTrainees": {
    "title": "Remove {{numberOfTrainees}} Trainees ",
    "notification": {
      "traineesRemoved": "Removed {{numberOfTrainees}} Trainees."
    }
  },
  "removedApplicants": {
    "title": "Remove {{numberOfApplicants}} Applicants ",
    "notification": {
      "applicantsRemoved": "Removed {{numberOfApplicants}} Applicants."
    },
    "stepLabels": {
      "verifyApplicantList": "Verify Applicant List"
    }
  },
  "removedOutcomes": {
    "title": "Remove {{numberOfTrainees}} Trainees ",
    "notification": {
      "traineesRemoved": "Removed {{numberOfTrainees}} Trainees."
    }
  },
  "accessDenied": {
    "title": "Access Denied",
    "accessDeniedMessage": "You do not have access to this page.",
    "requireAccessMessage": "If you require access to it, please contact"
  },
  "dataSources": {
    "view": {
      "gst": "Graduate Student Tracking",
      "opa": "Office of Postdoctoral Affairs",
      "peopleSoft": "PeopleSoft",
      "rmg": "Research Management Group",
      "traineePortal": "Trainee Portal"
    }
  }
}
